import React from "react";
import PuffLoader from "react-spinners/PuffLoader";

const Spinner = ({ loading }) => {
  const override = {
    display: "block",
    margin: "100px auto",
    position: "absolute",
    top: "30%",
    left: "50%",
    right: "50%",
    zIndex: "9999",
  };
  return (
    <PuffLoader
      color="rgb(0, 10, 101)"
      loading={loading}
      cssOverride={override}
      size={80}
    />
  );
};

export default Spinner;
